// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2641":"fd7f5cc2","8473":"fd7f5cc2"}[chunkId] + ".chunk.css";
};